import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M21.5 4a1.5 1.5 0 00-3 0v11.76a.25.25 0 01-.15.23.26.26 0 01-.28-.05l-13-13a1.5 1.5 0 00-2.13 2.12l13 13a.24.24 0 010 .27.25.25 0 01-.23.15H4a1.5 1.5 0 000 3h15a2.5 2.5 0 001.78-.74A2.53 2.53 0 0021.5 19z" }));
export {
  t as default
};
